import { Component, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/services/config/config.service';
import { LobbyNavigator } from 'src/app/services/lobby/lobby-navigator.service';

@Component({
  selector: 'app-site-logo',
  templateUrl: './site-logo.component.html',
})

export class SiteLogoComponent implements OnInit {

  constructor(
    private readonly config: ConfigService,
    private readonly lobbyNavigation: LobbyNavigator,
  ) { }

  ngOnInit(): void {

  }

  protected onLogoClick() {
    return this.lobbyNavigation.goToMainPage();
  }

}
